module.exports = __webpack_public_path__ + "img/hengfu.2f9efacb.jpg";